<template>
	<div
	v-if="authenticated || puede_comprar_sin_login">
		
		<div
		v-if="article && !flag_activo(article.precio_pausado) && articlePriceEfectivo(article) && hasStock(article)"
		class="add-to-cart m-b-20">
			
			<notes
			:article="article"></notes>	
			

			<div class="cont-input-btn-add">
				<amount
				@addToCart="agregar_al_carrito"
				:article="article"></amount>
			
				<b-button
				v-if="!is_item_in_cart(article)"
				@click="agregar_al_carrito"
				:disabled="amount == '' || amount == 0"
				variant="outline-primary"
				class="add-to-cart__btn-add"
				v-b-tooltip.hover="{ title: 'Agregar al carrito', boundary: 'viewport' }"
				aria-label="Agregar al carrito">
					<span
					v-if="saving"
					class="spinner-border spinner-border-sm"
					role="status"
					aria-hidden="true"></span>
					<span
					v-else
					class="add-to-cart__btn-add-icons"
					aria-hidden="true">
						<i class="bi bi-cart"></i>
						<i class="bi bi-plus-lg add-to-cart__btn-add-plus"></i>
					</span>
				</b-button>
				
				<div
				v-else>
					<b-button-group
					class="add-to-cart__btn-group">
						
						<b-button
						v-b-tooltip.hover="actualizar_carrito_tooltip_config"
						@click="update_article_cart"
						variant="success"
						:class="{ 'add-to-cart__btn-actualizar--disabled': actualizar_carrito_disabled }"
						:aria-disabled="actualizar_carrito_disabled ? 'true' : 'false'"
						block>
							Actualizar
						</b-button>
						<b-button
						class="m-0"
						@click="remove_cart(article)"
						variant="outline-primary"
						>
							<i class="bi bi-cart-x" aria-hidden="true"></i>
						</b-button>
					</b-button-group>
				</div>
			</div>
		</div>

		<agotado-info
		:article="article"
		v-else></agotado-info>
	</div>
</template>
<script>
import articles from '@/mixins/articles'
import { trackear, TIPOS_EVENTO } from '@/utils/tracking'
export default {
	name: 'AddToCart',
	mixins: [articles],
	props: {
		article: Object,
	},
	components: {
		Amount: () => import('@/components/article/components/data/add-to-cart/Amount'),
		AgotadoInfo: () => import('@/components/article/components/data/add-to-cart/AgotadoInfo'),
		Notes: () => import('@/components/article/components/data/add-to-cart/Notes'),
	},
	computed: {
		/**
		 * Indica si el botón "Actualizar" debe estar deshabilitado (sin cantidad válida).
		 */
		actualizar_carrito_disabled() {
			return this.amount === '' || Number(this.amount) === 0
		},
		/**
		 * Configuración del tooltip al pasar el mouse: solo activo cuando el botón está deshabilitado.
		 */
		actualizar_carrito_tooltip_config() {
			return {
				title: 'Indicá una nueva cantidad para poder actualizar el carrito.',
				disabled: !this.actualizar_carrito_disabled,
			}
		},
		amount() {
			return this.$store.state.articles.amount
		},
		notes() {
			return this.$store.state.articles.notes
		},
		selected_article_variant() {
			return this.$store.state.articles.selected_article_variant
		},
		cart() {
			return this.$store.state.cart.cart
		},
	},
	data() {
		return {
			saving: false,
		}
	},
	methods: {
		buyNow() {
			this.saveCart(true)
		},
		agregar_al_carrito() {
			// Si el precio está pausado, no se permite agregar al carrito.
			if (this.article && this.flag_activo(this.article.precio_pausado)) {
				this.$toast.warning('Este artículo no está disponible para agregar al carrito')
				return
			}
			this.saveCart()
		},
		/**
		 * Persiste la nueva cantidad del artículo en el carrito (API). No hace nada si la cantidad no es válida.
		 */
		update_article_cart() {
			// Sin `disabled` nativo: el tooltip puede recibir hover; aquí se evita el PUT inválido.
			if (this.actualizar_carrito_disabled) {
				return
			}
			console.log(this.article)
			console.log(this.article.is_promocion_vinoteca)
			let is_promocion_vinoteca = typeof this.article.is_promocion_vinoteca != 'undefined' ? true : false

			this.$store.commit('auth/setMessage', 'Cargando')
			this.$store.commit('auth/setLoading', true)
			this.$api.put('carts/update-article-amount/'+this.cart.id, {
				id: this.article.id,
				is_promocion_vinoteca: is_promocion_vinoteca,
				amount: this.amount
			})
			.then(res => {
				this.$store.commit('cart/setCart', res.data.cart)
				this.$store.commit('auth/setLoading', false)
				this.$toast.success('Carrito actualizado')
			})
			.catch(err => {
				this.$store.commit('auth/setLoading', false)
				this.$toast.error(err)
			})
		},
		saveCart(buy_now = false) {
			// Doble validación por seguridad para evitar altas al carrito por eventos manuales.
			if (this.article && this.flag_activo(this.article.precio_pausado)) {
				this.$toast.warning('Este artículo no está disponible para agregar al carrito')
				return
			}

			let amount = Number(this.amount)
			
			if (amount == ''
				|| amount <= 0) {
				this.$toast.error('Indique una cantidad')
				return
			}
			if (this.checkVariant()) {
				console.log('paso variants')
				this.article.amount = amount 
				this.article.notes = this.notes 
				this.article.pivot = {
					amount: amount,
					notes: this.notes,
					variant_id: this.selected_article_variant ? this.selected_article_variant.id : null,
					price: this.articlePriceEfectivo(this.article, false)
				}
				this.$store.commit('cart/addItem', this.article)
				/*
				 * 🔴 El evento sale del llamador y NO de la mutación. cart/addItem es un
				 * TOGGLE: si el artículo ya estaba en el carrito lo saca. Emitirlo desde la
				 * mutación produciría un cart_add cuando en realidad se quitó. Acá sí se
				 * conoce la intención: este método corre desde el botón "Agregar al carrito",
				 * que solo se muestra cuando el artículo todavía no está en el carrito.
				 * Además, meter I/O adentro de una mutación de Vuex es justo lo que no se hace.
				 */
				let precio_unitario = this.article.pivot.price
				trackear(TIPOS_EVENTO.CARRITO_AGREGAR, {
					article_id: this.article.id,
					category_id: this.article.category_id,
					sub_category_id: this.article.sub_category_id,
					quantity: amount,
					/* Con precios ocultos por configuración el precio viene null: ahí no se manda monto. */
					amount: precio_unitario != null && isFinite(precio_unitario)
						? Number(precio_unitario) * amount
						: null,
				})
				if (this.authenticated) {

					this.$bvModal.hide('add-to-cart-modal')
					this.$store.commit('auth/setMessage', 'Guardando carrito')
					this.$store.commit('auth/setLoading', true)
					this.$store.dispatch('cart/save')
					.then(() => {

						this.$store.commit('cart/set_added_item', this.article)

						this.$store.commit('auth/setLoading', false)

						if (buy_now) {
							this.$router.push({name: 'Payment'})
						} else {
							this.$store.commit('cart/set_added_item_popup_visible', true)
						}


						this.$store.commit('articles/setAmount', '')
						this.$store.commit('articles/setNotes', '')

					})
					.catch(err => {
						this.$store.commit('auth/setLoading', false)
						console.log(err)
						this.$toast.error('Error al guardar carrito')
					})

				} else {
					// Guest checkout: carrito local sin persistir en API hasta el paso de pago.
					this.$bvModal.hide('add-to-cart-modal')
					this.$store.commit('cart/set_added_item', this.article)
					this.$store.commit('cart/set_added_item_popup_visible', true)
					this.$store.commit('articles/setAmount', '')
					this.$store.commit('articles/setNotes', '')
				}
			}
		},
		addToCartCookie() {
			localStorage.cart = JSON.stringify(this.cart) 
		},
		checkVariant() {
			let ok = true 
			if (
				this.article.article_properties
				&& this.article.article_properties.length
			) {
				this.article.article_properties.forEach(property => {
					if (this.article.selected_article_properties[property.id] == 0) {
						this.$toast.error('Seleccione '+property.article_property_type.name)
						ok = false 
					}
				})
			}
			return ok 
		},
		checkColors() {
			if (this.article.colors.length) {
				if (this.article.pivot.color_id) {
					return true
				} else {
					this.$toast.warning('Seleccione un color')	
					return false				
				}
			}
			return true
		},
		checkSizes() {
			if (this.article.sizes.length) {
				if (this.article.size) {
					return true
				} else {
					this.$toast.warning('Seleccione un talle')	
					return false				
				}
			}
			return true
		},
		removeArticleFromCookies() {
			this.$cookies.keys().forEach(key => {
				if (key.includes('article_'+this.article.id)) {
					this.$cookies.remove(key)
				}
			})
		},
	}
}
</script>
<style scoped lang="sass">
@import '@/sass/_custom'
.add-to-cart
	display: flex 
	flex-direction: column
	border-top: 1px solid rgba(0,0,0, .1)
	padding-top: 10px

	.cont-input-btn-add
		width: 100%
		display: flex
		flex-direction: row
		align-items: stretch
		gap: 0.5rem

		::v-deep .article-amount
			flex: 1
			min-width: 0

		::v-deep .article-amount input
			width: 100% !important
			height: 100%

		.add-to-cart__btn-add
			flex-shrink: 0
			width: auto !important
			margin-left: 0
			padding: 0 0.7rem
			display: inline-flex
			align-items: center
			justify-content: center
			align-self: stretch

		.add-to-cart__btn-add-icons
			position: relative
			display: inline-flex
			align-items: center
			justify-content: center
			width: 1.35rem
			height: 1.35rem
			font-size: 1.15rem
			line-height: 1

		.add-to-cart__btn-add-plus
			position: absolute
			right: -0.35rem
			bottom: -0.2rem
			font-size: 0.62rem
			font-weight: 700
			line-height: 1
			padding: 0.05rem
			border-radius: 50%
			background: #fff

		.add-to-cart__btn-group
			flex: 1
			min-width: 0

	.add-to-cart__btn-actualizar--disabled
		opacity: 0.65
		cursor: not-allowed
		box-shadow: none
</style>